import { render, staticRenderFns } from "./AmostrasCatalisadoresLaboratorioMatrizFinalizadas.vue?vue&type=template&id=1dd4deec&"
import script from "./AmostrasCatalisadoresLaboratorioMatrizFinalizadas.vue?vue&type=script&lang=ts&"
export * from "./AmostrasCatalisadoresLaboratorioMatrizFinalizadas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSelect,VSnackbar,VTextField})
